import React, { useEffect, useState } from "react";
import { db } from "@/config/firebase";
import { collection, getDocs, query } from "firebase/firestore";

export default function Chronicle() {
  const [votes, setVotes] = useState([]);
  useEffect(() => {
    (async () => {
      const v = await getDocs(query(collection(db, "overperformer_votes")));
      setVotes(v.docs.map(d=>({ id:d.id, ...d.data()})));
    })();
  }, []);
  return (
    <div className="pb-28 min-h-screen bg-[#0e0b0c] text-rose-50 px-4 pt-6">
      <h2 className="text-xl font-bold mb-4">Chronik</h2>
      {votes.length===0 ? <p className="text-sm text-rose-200/80" data-testid="empty-chronicle">Noch keine Stimmen.</p> : (
        <ul className="space-y-2" data-testid="chronicle-list">
          {votes.map(v => (
            <li key={v.id} className="p-3 rounded-lg bg-[#1a0d11] border border-white/10">
              <p className="text-sm">{v.category} • Event {v.event_id}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
